<template>
    <div class="modal-game-field">
        <h4 v-i18n="'CHOOSE_GAME_FIELD'" />
        <select v-model="game_field" class="hg-select">
            <option v-for="c in game_fields" 
                    :key="c.name" 
                    :value="c" 
                    v-i18n="c.name">
            </option>
        </select>
        <button class="hg-button" v-i18n="'SELECT'" @click="onSelect(game_field)"/>
    </div>
</template>
<style scoped>
.modal-game-field{
    padding: 20px;
}
</style>
<script>
export default {
    props: {
        selections : {type: Array},
        onSelect: {type: Function}
    },
    data(){
        return {
            game_field: null
        }
    },
    computed:{
        game_fields(){
            if(!this.selections) return [];

            return this.selections;
        }
    }
}
</script>